import { debounce } from "../application";

document.addEventListener("turbo:load", function () {
    if (!document.documentElement.hasAttribute('data-turbo-native-app')) {
        initProductIndexAds();
        initComparisonIndexAds();
        initIngredientsExplainedAds();
    }
});

document.addEventListener("turbo:frame-load", function () {
    if (!document.documentElement.hasAttribute('data-turbo-native-app')) {
        initProductIndexAds();
        initIngredientsExplainedAds();
    }
});

document.addEventListener("turbo:after-stream-render", debounce(function () {
    if (!document.documentElement.hasAttribute('data-turbo-native-app')) {
        initProductIndexAds();
    }
}, 250));

function insertHint(element, className) {
    let hint = document.createElement("div");
    hint.classList.add(className);
    element.insertAdjacentElement("afterend", hint);
}

function initComparisonIndexAds() {
    let comparisonsTable = document.getElementById('comparisons-list');

    if (comparisonsTable) {
        Array.from(comparisonsTable.children).forEach(function (comparisonElement, index) {
            insertHint(comparisonElement, "content_mobile_hint");

            if ((index - 1) % 2 == 0) {
                insertHint(comparisonElement, "content_desktop_hint");
            }
        });
    }
}

function initIngredientsExplainedAds() {
    let ingredientsExplainedList = document.getElementById('ingredients-explained-list');

    if (ingredientsExplainedList) {
        // Early exit if we've already inserted the hints
        if (ingredientsExplainedList.querySelector('.content_mobile_hint, .content_desktop_hint')) {
            return;
        }

        Array.from(ingredientsExplainedList.querySelectorAll(".ingredient-table-row")).forEach(function (ingredientRow, index) {
            if ((index - 1) % 2 == 0) {
                insertHint(ingredientRow, "content_mobile_hint");
            }

            if ((index - 1) % 3 == 0) {
                insertHint(ingredientRow, "content_desktop_hint");
            }
        });
    }
}

function initProductIndexAds() {
    document.querySelectorAll('#products-table').forEach(function (productsTable) {
        // Keep this catalog mobile-only: any manual Mediavine hint disables
        // automatic placement, and desktop ads disrupt the product grid.
        let productCards = Array.from(productsTable.querySelectorAll(':scope > [data-product-card-id]'));

        productCards.forEach(function (productCard, index) {
            let isFourthProduct = (index + 1) % 4 === 0;
            let alreadyHasMobileHint = productCard.nextElementSibling?.classList.contains('content_mobile_hint');

            if (isFourthProduct && !alreadyHasMobileHint) {
                insertHint(productCard, "content_mobile_hint");
            }
        });
    });
}
